





























import Vue from "vue";
import iwInputPrice from "@/encoding/components/buildingBlocks/InputPrice.vue";
import iwTooltip from "@/shared/components/Tooltip.vue";
import { v4 as uuidv4 } from "uuid";

export default Vue.extend({
    components: {
        iwInputPrice: iwInputPrice,
        iwTooltip: iwTooltip
    },
    data: function() {
        return {
            pathInStore: "transaction.sale.cadastralIncome",
            inputName: "cadastral-income",
            specificId: uuidv4() as string
        };
    },
    computed: {
        isDisplayed: function(): boolean {
            return this.$store.getters["FormModule/getValue"]("transaction.type") === "FOR_SALE";
        },
        cadastralIncome: function(): string  {
            return this.$store.getters["FormModule/getValue"](this.pathInStore) ?? "";
        },
    },
    mounted: function() {
        if (!this.isDisplayed) {
            this.$store.commit("FormModule/deleteValue", this.pathInStore);
        }
    },
    methods: {
        updateValue: function(cadastralIncome: number): void {
            if (cadastralIncome === 0) {
                this.$store.commit("FormModule/deleteValue", this.pathInStore);
            } else {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStore, "value": cadastralIncome});
            }
        }
    }
});
